import sjcl from 'sjcl';
import { httpGet, httpPost, httpDelete, httpPut } from "./AbstractService";
import { paddy } from "./StringService";
import ENDPOINTS from "../data/endpoints.json";

export const EVENT_QR_KEY = "50yI5vBNwJ5fgphjWzSI6LlCkfPFu8DN";

export const getEventTypes = (school, jwt) => {
  return httpGet( jwt, `${ENDPOINTS[school.region].school}/event-type`);
};

export const getTeacherEvents = (school, jwt, dateStart, dateEnd) => {
  return httpGet( jwt, `${ENDPOINTS[school.region].school}/event/teacher/date/${dateStart}/${dateEnd}`);
};

export const saveEvent = (
  school,
  jwt,
  eid,
  title,
  studentEids,
  date,
  startHour,
  startMinute,
  endHour,
  endMinute,
  eventTypeEid,
  teacherEids,
  description,
  userListEids,
  allowSignup,
  autoSignup,
  whoCanView,
  selectedLocation,
  maxStudents,
  passTypeEid
) => {
  const values = {
    title,
    studentEids,
    date,
    startHour,
    startMinute,
    endHour,
    endMinute,
    eventTypeEid,
    teacherEids,
    description,
    userListEids,
    allowSignup,
    autoSignup,
    whoCanView,
    selectedLocation,
    maxStudents,
    passTypeEid
  };

  if (eid == null) {
    return httpPost( jwt, `${ENDPOINTS[school.region].school}/event`, values);
  } else {
    return httpPut( jwt, `${ENDPOINTS[school.region].school}/event/${eid}`, values);
  }
};

export const getSchoolEvent = (school, jwt, eid) => {
  return httpGet( jwt, `${ENDPOINTS[school.region].school}/event/${eid}`);
};

export const deleteSchoolEvent = (school, jwt, eid) => {
  return httpDelete( jwt, `${ENDPOINTS[school.region].school}/event/${eid}`);
};

export const getEventSignupMembers = (school, jwt, eid) => {
  return httpGet( jwt, `${ENDPOINTS[school.region].school}/event/${eid}/signup/member`);
};

export const updateEventStatus = (school, jwt, eventEid, attendees) => {
  return httpPut( jwt, `${ENDPOINTS[school.region].school}/event/${eventEid}/attend`, { attendees });
};

export const removeEventAttendee = (school, jwt, eventEid, memberEid) => {
  return httpDelete( jwt, `${ENDPOINTS[school.region].school}/event/attend/${memberEid}`);
};

export const addStudentsToEvent = (school, jwt, eventEid, studentEids) => {
  return httpPut( jwt, `${ENDPOINTS[school.region].school}/event/${eventEid}/signup/member`, {
    studentEids,
  });
};

export const getEventStartTime = (evt) => {
  let startHour = evt.startHour;
  let ampm = "am";

  if (evt.startHour === 0) {
    startHour = 12;
    ampm = "am";
  }
  if (evt.startHour >= 12) {
    ampm = "pm";
  }
  if (evt.startHour > 12) {
    startHour -= 12;
  }

  return `${paddy(startHour, 2, "0")}:${paddy(
    evt.startMinute,
    2,
    "0"
  )} ${ampm}`;
};

// factors in the periodLength
export const getEventEndTime = (evt) => {
  let endHour = evt.endHour;
  let ampm = "am";

  if (evt.endHour === 0) {
    endHour = 12;
    ampm = "am";
  }
  if (evt.endHour >= 12) {
    ampm = "pm";
  }
  if (evt.endHour > 12) {
    endHour -= 12;
  }

  return `${paddy(endHour, 2, "0")}:${paddy(evt.endMinute, 2, "0")} ${ampm}`;
};

export const getStudentEvents = (school, jwt, dateStart, dateEnd) => {
  return httpGet( jwt, `${ENDPOINTS[school.region].school}/event/student/date/${dateStart}/${dateEnd}`);
};

export const saveEventType = (
  school,
  jwt,
  eid,
  name,
  description,
  autoSignUp,
  allowSignUp,
  isGuardianEvent
) => {
  const values = {
    name,
    description,
    autoSignUp,
    allowSignUp,
    isGuardianEvent
  };

  if (eid == null) {
    return httpPost( jwt, `${ENDPOINTS[school.region].school}/event-type`, values);
  } else {
    return httpPut( jwt, `${ENDPOINTS[school.region].school}/event-type/${eid}`, values);
  }
};

export const deleteEventType = (school, jwt, eid) => {
  return httpDelete( jwt, `${ENDPOINTS[school.region].school}/event-type/${eid}`);
};

export const addStudentToEvent = (school, jwt, eventEid) => {
  return httpPut( jwt, `${ENDPOINTS[school.region].school}/event/${eventEid}/signup/indiv`, {
  });
};

export const removeStudentFromEvent = (school, jwt, eventEid) => {
  return httpPut( jwt, `${ENDPOINTS[school.region].school}/event/${eventEid}/signup/remove`, {
  });
};

export const encryptEventAttend = (key, eid) => {
  const value = `${eid}`;
  return btoa(sjcl.encrypt(key, value));
}

export const addGuardianToEvent = (school, jwt, eventEid, email, lastName, firstName, students) => {
  return httpPost( jwt, `${ENDPOINTS[school.region].school}/event/${eventEid}/guardian`, {
    email, lastName, firstName, students
  });
};

export const getSchoolEvents = (school, jwt, eid) => {
  return httpGet( jwt, `${ENDPOINTS[school.region].school}/event/school`);
};

